/*jshint esversion: 8*/
/* Common functions to be used in different components.
 * HISTORY: no-version
 * 05/24/22(B0.7): Added BEH_FIELDS and getAllBehavioralFields().
 * 09/24/21(B0.6): In adjustFilter(), changed originalFilter to currentFilter and added originalFilter param +
 *    Added adjustFiletr_matchKeyExists() and adjustFiletr_eventKeyExists functions.
 * 09/21/21(B0.5): In adjustFilter(), added $addFields only if didn't exist.
 * 09/17/21(B0.4): In adjustFilter(), made event_date's values to be in ISO format.
 * 09/13/21(B0.3): Added adjustFilter() and adjustFilter_isEmpty().
 * 04/19/21(B0.2): Added isValidDate().
 * 11/24/20(B0.1): Creation date.
 */

// export default {
//    methods: {
//       clicked(value) {
//          alert(value);
//       }
//    }
//  };

const BEH_FIELDS = [
   { text: 'App Code', value: 'app_code', type: 'string', isEventField: true },
   { text: 'Browser', value: 'browser', type: 'string', isEventField: true },
   { text: 'Event Code', value: 'event_code', type: 'string', isEventField: true },
   { text: 'Event Date', value: 'event_date', type: 'date', isEventField: true },
   { text: 'IP', value: 'ip', type: 'string', isEventField: true },
   // { text: 'Is Trigger', value: 'is_trigger', type: 'boolean', isEventField: true },
   { text: 'Operating System', value: 'os', type: 'string', isEventField: true }
   // { text: 'Process Definition ID', value: 'pdid', type: 'string', isEventField: true }
];
 
// This function is used inside adjustFilter().
function adjustFilter_isEmpty(val) {
   if ((typeof val === 'string' && val === '') || (Array.isArray(val) && val.length === 0))
      return true;
   else
      return false;
}

function adjustFiletr_matchKeyExists(filter, key) {
   // alert('in adjustFiletr_matchKeyExists(): filter=' + JSON.stringify(filter) + '\n\tkey=' + key);
   const match = filter.standard.find(f => f.$match).$match;
   const result = match.hasOwnProperty(key);
   // alert('in adjustFiletr_matchKeyExists(): result=' + result);
   return result;
}

function adjustFiletr_eventKeyExists(filter, key) {
   // alert('in adjustFiletr_eventKeyExists(): filter=' + JSON.stringify(filter) + '\n\tkey=' + key);
   const eventsObj = filter.standard.find(f => f.$events);
   const result = eventsObj ? eventsObj.events.$elemMatch.hasOwnProperty(key) : false;
   // alert('in adjustFiletr_eventKeyExists(): result=' + result);
   return result;
}

export function test(value) {
   alert(value);
}

//usage: await sleep(2000);
export function sleep(ms) {
   // alert('ms=' + ms);
   return new Promise(resolve => setTimeout(resolve, ms));
}

//to generate an integer random number between min and max.
export function getRandomInt(min, max) {
   return min + Math.floor(Math.random() * (max - min));
}


/*
 * To check if an item exists in an array or not.
 * src: array of strings to be searched in.
 * item: a string to be searched for.
 * returns true or false.
 */
export function isIncluded(src, item, isCaseSensitive) {
   // alert('src=' + JSON.stringify(src) + '\nitem=' + item + '\nisCaseSensitive=' + isCaseSensitive);
   if (isCaseSensitive)
      return src.filter(s => s.includes(item)).length > 0;
   else
      return src.filter(s => s.toLowerCase().includes(item.toLowerCase())).length > 0;
}

/*
 * https://stackoverflow.com/questions/6177975/how-to-validate-date-with-format-mm-dd-yyyy-in-javascript
 * To validate a date string
 * date: a date string in the form of 'mm/dd/yyyy'
 * returns true or false
 */
export function isValidDate(date) {
   // date should be in "mm/dd/yyyy" format
   if ( ! /^\d\d\/\d\d\/\d\d\d\d$/.test(date) )
       return false;

      //  const parts = date.split('/').map((p) => parseInt(p, 10));
      //  parts[0] -= 1;
      //  const newDate = new Date(parts[2], parts[0], parts[1]);
      //  return newDate.getMonth() === parts[0] && newDate.getDate() === parts[1] && newDate.getFullYear() === parts[2];

   let [mm, dd, yyyy] = date.split('/').map((p) => parseInt(p, 10));
   mm -= 1;
   const newDate = new Date(yyyy, mm, dd);
   return newDate.getMonth() === mm && newDate.getDate() === dd && newDate.getFullYear() === yyyy;
}

/*
 * Business Logics:
 * - No changes should affect itself and DatePicker.
 * - date-picker-change should update all other filters.
 * Note: What happens when a dropdown is already selected but this item is not available when date is changed?
 * Note: What happens to the originalFilter if date is changed again. 
 * - dropdown-change shouldn't affect KPIs.
 * - chart-click only affects other charts and tables.
 * Note: What happens if another chart is clicked.
 */
export function adjustFilter(originalFilter, currentFilter, adjustingFilter, chartType) {
   // alert('in bt-mixin.adjustFilter(): originalFilter=' + JSON.stringify(originalFilter) +
   //    '\n\tcurrentFilter=' + JSON.stringify(currentFilter) +
   //    '\n\tadjustingFilter=' + JSON.stringify(adjustingFilter) +
   //    '\n\tchartType=' + chartType);
   const filter = JSON.parse(JSON.stringify(currentFilter));
   let partialFilter;
   if (Array.isArray(adjustingFilter) || typeof adjustingFilter === 'string')
      partialFilter = { event_date: adjustingFilter };
   else
      partialFilter = adjustingFilter;

   const newEvents = {};
   const $match = filter.standard.find(f => f.$match).$match;
   Object.keys(partialFilter).filter(k => k.toString() != '$addFields' && k.toString() != '$dropdownSwitch').forEach(key => {
      // alert('in bt-mixin.adjustFilter(): key=' + key);
      const val = partialFilter[key];
      switch (key) {
         case 'app_code':
         case 'event_code':
            if (!adjustFiletr_eventKeyExists(originalFilter, key)) {
               if (adjustFilter_isEmpty(val))
                  delete newEvents[key];
               else
                  newEvents[key] = { '$in': Array.isArray(val) ? val : [val] };
            }            
            break;
         case 'event_date':
            if (!adjustFiletr_eventKeyExists(originalFilter, key)) {
               if (adjustFilter_isEmpty(val))
                  delete newEvents[key];
               else {
                  let val1, val2;
                  if (Array.isArray(val)) {
                     val1 = val[0];
                     val2 = val[1];
                  } else {
                     val1 = val;
                     val2 = val;
                  }
                  val1 += 'T00:00:00.000Z';
                  val2 += 'T23:59:59.999Z';
                  newEvents[key] = { '$gte': val1, '$lte': val2 };
                  // alert(JSON.stringify(newEvents[key]));
               }
            }
            break;
         case 'browser':
         case 'is_trigger':
         case 'os':
            if (!adjustFiletr_eventKeyExists(originalFilter, key)) {
               if (adjustFilter_isEmpty(val))
                  delete newEvents[key];
               else
                  newEvents[key] = Array.isArray(val) ? { '$in': val } : val;
            }
            break;
         default:
            if (!adjustFiletr_matchKeyExists(originalFilter, key)) {
               if (adjustFilter_isEmpty(val))
                  delete $match[key];
               else {
                  if (!partialFilter.hasOwnProperty('$dropdownSwitch') || partialFilter.$dropdownSwitch)
                     $match[key] = Array.isArray(val) ? { '$in': val } : val;
                  else
                     $match[key] = Array.isArray(val) ? { '$nin': val } : { '$ne': val };
               }
            }
            break;
      }
   });

   if (Object.keys(newEvents).length) {
      const eventsObj = filter.standard.find(f => f.$events);
      let events = eventsObj ? eventsObj.events : { $elemMatch: {} };

      Object.keys(newEvents).forEach(key => {
         events.$elemMatch[key] = newEvents[key];
      });

      $match.events = events;
   }

   if (partialFilter.hasOwnProperty('$addFields') && !filter.standard[0].hasOwnProperty('$addFields'))
      filter.standard.unshift({ $addFields: partialFilter.$addFields });
      
   // console.log('in bt-mixin.adjustFilter(): newFilter=' + JSON.stringify(filter));
   return filter;
}

export function getAllBehavioralFields() {
   return BEH_FIELDS;
}
